import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';

import IntegrationAppCard from './integrationAppCard';
import { useStyles } from './cardList.styles';

function CardList({ cardListData }) {
    const classes = useStyles();

    useEffect(() => {
        console.log('cardList() -> ');
    }, []);
    if (!cardListData) return null;

    return (
        <Grid container className={classes.cardListContainer}>
            {cardListData.map((item) => (
                <Grid item key={item.app} className={classes.cardItem}>
                    <IntegrationAppCard
                        app={item.app}
                        description={item.description}
                        icon={item.icon}
                        initials={item.initials}
                        type={item.type}
                    />
                </Grid>
            ))}
        </Grid>
    );
}

export default CardList;
